export const ROLE_DROPDOWN_DATA = [
  {
    id: 1,
    label: 'Owner',
    value: 'owner',
  },
  {
    id: 2,
    label: 'Agent',
    value: 'agent',
  },
  {
    id: 3,
    label: 'Builder',
    value: 'builder',
  },
  {
    id: 4,
    label: 'Admin',
    value: 'admin',
  },
];

export const EMAIL_TYPE_FILTER_OPTIONS = [
  {
    id: 1,
    label: 'Email Verified',
    value: 'verified',
  },
  {
    id: 2,
    label: 'Email Not Verified',
    value: 'not_verified',
  },
  {
    id: 3,
    label: 'Must Have Email',
    value: 'required',
  },
];

export const PHONE_VERIFIED_DROPDOWN_DATA = [
  {
    id: 1,
    label: 'Phone Verified',
    value: true,
  },
  {
    id: 2,
    label: 'Phone Not Verified',
    value: false,
  },
];

export const ADMIN_VERIFICATION_STATUS = [
  {
    id: 1,
    label: 'Admin Verified',
    value: 'true',
  },
  {
    id: 2,
    label: 'Admin Not Verified',
    value: 'false',
  },
];

export const ONBOARDING_DROPDOWN_DATA = [
  {
    id: 1,
    label: 'OnBoarded',
    value: 'true',
  },
  {
    id: 2,
    label: 'Not OnBoarded',
    value: 'false',
  },
];

export const PLATFORM_DROPDOWN_DATA = [
  {
    id: 1,
    label: 'Web',
    value: 'web',
  },
  {
    id: 2,
    label: 'iOS',
    value: 'ios',
  },
  {
    id: 3,
    label: 'Android',
    value: 'android',
  },
];

export const GENDER_FILTER_DROPDOWN_DATA = [
  {
    id: 1,
    label: 'Male',
    value: 'm',
  },
  {
    id: 2,
    label: 'Female',
    value: 'f',
  },
  {
    id: 3,
    label: 'Other',
    value: 'o',
  },
];

export const SELL_OR_RENT_TRANSACTION_TYPE_DATA = [
  {
    id: 1,
    label: 'Residential',
    value: 'residential_property',
  },
  {
    id: 2,
    label: 'Commercial',
    value: 'commercial_property',
  },
];

export const TRANSACTION_TYPE_DATA = [
  {
    id: 1,
    label: 'Residential',
    value: 'residential_property',
  },
  {
    id: 2,
    label: 'Commercial',
    value: 'commercial_property',
  },
  {
    id: 3,
    label: 'Plot',
    value: 'plot',
  },
  {
    id: 4,
    label: 'PG',
    value: 'PG',
  },
  {
    id: 5,
    label: 'Share Flat',
    value: 'share_flat',
  },
];

export const AD_TYPE_DATA = [
  {
    id: 1,
    label: 'Rent',
    value: 'rent',
  },
  {
    id: 2,
    label: 'Sale',
    value: 'sell',
  },
];

export const RENT_RESIDENTIAL_PROPERTY_TYPE = [
  {
    id: 1,
    label: 'Apartment',
    value: 'flat/apartment',
  },
  {
    id: 2,
    label: 'Individual Floor',
    value: 'floor',
  },
  {
    id: 3,
    label: 'Independent House',
    value: 'independent_house',
  },
  {
    id: 4,
    label: 'Independent Villa',
    value: 'vila/farm_house',
  },
  {
    id: 5,
    label: '1Rk/Studio House',
    value: '1_rk_studio',
  },
  {
    id: 6,
    label: 'Others',
    value: 'others',
  },
];

export const SELL_RESIDENTIAL_PROPERTY_TYPE = [
  {
    id: 1,
    label: 'Apartment',
    value: 'flat/apartment',
  },
  {
    id: 2,
    label: 'Individual Floor',
    value: 'floor',
  },
  {
    id: 3,
    label: 'Independent House',
    value: 'independent_house',
  },
  {
    id: 4,
    label: 'Independent Villa',
    value: 'vila/farm_house',
  },
  {
    id: 5,
    label: 'Plot/Land',
    value: 'plot',
  },
  {
    id: 6,
    label: 'Others',
    value: 'others',
  },
];

export const COMMERCIAL_PROPERTY_TYPE = [
  {
    id: 1,
    label: 'Office',
    value: 'office',
  },
  {
    id: 2,
    label: 'Retail Shop',
    value: 'retail_shop',
  },
  {
    id: 3,
    label: 'Showroom',
    value: 'showroom',
  },
  {
    id: 4,
    label: 'Warehouse',
    value: 'warehouse',
  },
  {
    id: 5,
    label: 'Others',
    value: 'others',
  },
];

export const PROPERTY_VERIFIED_TYPE = [
  {
    id: 1,
    label: 'Verified',
    value: true,
  },
  {
    id: 2,
    label: 'Not Verified',
    value: false,
  },
];

export const PROPERTY_STATUS = [
  {
    id: 1,
    label: 'Active',
    value: 'active',
  },
  {
    id: 2,
    label: 'Expired',
    value: 'expired',
  },
  {
    id: 3,
    label: 'Pending',
    value: 'pending_verification',
  },
  {
    id: 4,
    label: 'Deleted',
    value: 'deleted',
  },
  {
    id: 5,
    label: 'Inactive',
    value: 'inactive',
  },
  {
    id: 6,
    label: 'Rejected',
    value: 'rejected',
  },
  {
    id: 7,
    label: 'Hard Deleted',
    value: 'hard_deleted',
  }
];

export const PROJECT_LIST_STATUS = [
  {
    id: 1,
    label: 'Active',
    value: 'active',
  },
  {
    id: 3,
    label: 'Pending',
    value: 'pending_verification',
  },
  {
    id: 5,
    label: 'Inactive',
    value: 'inactive',
  },
  {
    id: 6,
    label: 'Rejected',
    value: 'rejected',
  },
  {
    id: 7,
    label: 'Edit',
    value: '/admin/form',
  },
];

export const USER_STATUS = [
  {
    id: 1,
    label: 'Active',
    value: 'active',
  },

  {
    id: 3,
    label: 'Pending',
    value: 'pending_verification',
  },

  {
    id: 5,
    label: 'Inactive',
    value: 'inactive',
  },
  {
    id: 6,
    label: 'Rejected',
    value: 'rejected',
  },
];

export const LISTING_SCORE_SORT = [
  {
    id: 1,
    label: 'High to Low',
    value: 'descending',
  },
  {
    id: 2,
    label: 'Low to High',
    value: 'ascending',
  },
];

export const POSTED_ON_SORT = [
  {
    id: 1,
    label: 'Latest',
    value: 'descending',
  },
  {
    id: 2,
    label: 'Earlier',
    value: 'ascending',
  },
];

export const SORT_TYPES = [
  {
    id: 1,
    label: 'Total Listing Score',
    value: 'total_listing_score',
  },
  {
    id: 2,
    label: 'Created At',
    value: 'created_at',
  },
  {
    id: 3,
    label: 'Expires On',
    value: 'expires_on',
  },
];

export const SORT_DIRECTIONS = [
  {
    id: 1,
    label: 'Descending',
    value: 'descending',
  },
  {
    id: 2,
    label: 'Ascending',
    value: 'ascending',
  },
];

export const JOB_APPLICATION_STATUS_DATA = [
  {
    id: 1,
    label: 'Need To Complete Assignment',
    value: 'need_to_complete_assignment',
  },
  {
    id: 2,
    label: 'Assignment Submitted',
    value: 'assignment_submitted',
  },
  {
    id: 3,
    label: 'Assignment Reviewed',
    value: 'assignment_reviewed',
  },
  {
    id: 4,
    label: 'Rejected',
    value: 'rejected',
  },
  {
    id: 5,
    label: 'Shortlisted',
    value: 'shortlisted',
  },
];
export const JOB_APPLICATION_EXPERIENCE_DATA = [
  {
    id: 1,
    label: 'Fresher',
    value: 'fresher',
  },
  {
    id: 2,
    label: '0 to 1 Years',
    value: '0_to_1',
  },
  {
    id: 3,
    label: '1 to 3 Years',
    value: '1_to_3',
  },
  {
    id: 4,
    label: '3 to 5 Years',
    value: '3_to_5',
  },
  {
    id: 5,
    label: '5 to 10 Years',
    value: '5_to_10',
  },
  {
    id: 6,
    label: '10 + Years',
    value: '10_plus_years',
  },
];

export const JOB_WORK_PREFERENCE_DATA = [
  {
    id: 1,
    label: 'Work From Office',
    value: 'wfo',
  },
  {
    id: 2,
    label: 'Hybrid',
    value: 'hybrid',
  }
];

export const PROJECT_STATUS_DATA = [
  {
    id: 1,
    label: 'Ready to Move',
    value: 'ready_to_move',
  },
  {
    id: 2,
    label: 'Under Construction',
    value: 'under_construction',
  },
  {
    id: 3,
    label: 'Upcoming',
    value: 'upcoming',
  },
];

export const USER_ACTIVITY_ROLE_DATA = [
  {
    id: 1,
    label: 'Owner',
    value: 'owner',
  },
  {
    id: 2,
    label: 'Admin',
    value: 'admin,marketing_admin,hr_admin',
  },
  {
    id: 3,
    label: 'Agent',
    value: 'agent_dealer',
  },
  {
    id: 4,
    label: 'Builder',
    value: 'builder',
  },
];

export const PROPERTY_TYPE_LIST = [
  {
    id: 1,
    label: 'Apartment',
    value: 'flat/apartment',
  },
  {
    id: 2,
    label: 'Individual Floor',
    value: 'floor',
  },
  {
    id: 3,
    label: 'Independent House',
    value: 'independent_house',
  },
  {
    id: 4,
    label: 'Independent Villa',
    value: 'vila/farm_house',
  },
  {
    id: 5,
    label: '1Rk/Studio House',
    value: '1_rk_studio',
  },
  {
    id: 6,
    label: 'Office',
    value: 'office',
  },
  {
    id: 7,
    label: 'Warehouse',
    value: 'warehouse',
  },
  {
    id: 8,
    label: 'Retail Shop',
    value: 'retail_shop',
  },
  {
    id: 9,
    label: 'Showroom',
    value: 'showroom',
  },
  {
    id: 10,
    label: 'Plot',
    value: 'plot',
  },
  {
    id: 11,
    label: 'PG',
    value: 'PG',
  }
]

export const USER_LEAD_FILTER_OPTIONS = [
  {
    id: 1,
    label: 'All Shared Pending',
    value: 'all_leads',
  },
  {
    id: 2,
    label: 'Shared',
    value: 'shared',
  },
  {
    id: 3,
    label: 'Unshared',
    value: 'unshared',
  },
];

export const REQUIREMENT_TYPE_DATA = [
  {
    id: 1,
    label: 'Rent',
    value: 'rent',
  },
  {
    id: 2,
    label: 'Buy',
    value: 'sell',
  }
]

export const SUBSCRIPTION_STATUS = [
  { label: 'Active', value: 'active' },
  { label: 'Expired', value: 'expired' },
];

export const ORDER_STATUS = [
  { value: "paid", label: "Paid" },
  { value: "created", label: "Created" },
  { value: "failed", label: "Failed" },
  { value: "cancelled", label: "Cancelled" },
  // Add more status options as needed
];

export const SUB_STATUS =[
  {label:'user', value:'user'},
  {label:'ad', value:'ad'}
]


export const PLAN_STATUS = [
  {
    id: 1,
    label: 'Active',
    value: 'active',
  },
  {
    id: 2,
    label: 'Inactive',
    value: 'inactive',
  }
];

export const PLAN_USER_TYPE = [
  {
    id: 1,
    label: 'Tenant',
    value: 'tenant',
  },
  {
    id: 2,
    label: 'Buyer',
    value: 'buyer',
  },
  {
    id: 3,
    label: 'Agent',
    value: 'agent',
  },
  {
    id: 4,
    label: 'PG Owner',
    value: 'pg_owner',
  },
  {
    id: 5,
    label: 'Landlord',
    value: 'landlord',
  },
  {
    id: 6,
    label: 'Seller',
    value: 'seller',
  },
  {
    id: 7,
    label: 'Co Living',
    value: 'co_living',
  }
];

export const USER_REQUEST_STATUS = [
  {
    id: 1,
    label: 'Pending',
    value: 'pending',
  },
  {
    id: 2,
    label: 'Fulfilled',
    value: 'fulfilled',
  },
  {
    id: 3,
    label: 'Ignored',
    value: 'ignored',
  },
  {
    id: 3,
    label: 'Deleted',
    value: 'deleted',
  },
];

export const USER_REQUEST_TYPES = [
  {
    id: 1,
    label: 'Plan Upgrade',
    value: 'plan_upgrade',
  },
  {
    id: 2,
    label: 'Callback Requested',
    value: 'callback_requested',
  },
  {
    id: 3,
    label: 'Direct Lead',
    value: 'direct_lead',
  },
  {
    id: 4,
    label: 'Co-Living',
    value: 'co_living',
  },
  {
    id: 5,
    label: 'Post Property',
    value: 'POST_PROPERTY_PAGE',
  }
];

export const PLAN_USAGE_KEY = [
  {
    id: 1,
    label: 'View Number',
    value: 'view_number',
  },
  {
    id: 2,
    label: 'Listing',
    value: 'listings',
  },
];

export const PLAN_USAGE_REF_TYPE = [
  {
    id: 1,
    label: 'Leads',
    value: 'leads',
  },
  {
    id: 2,
    label: 'Admin Leads',
    value: 'admin_leads',
  },
];

export const LIMIT_EXHAUSTED_OPTIONS = [
  {
    id: 1,
    label: 'Exhausted',
    value: 'true',
  },
  {
    id: 2,
    label: 'Not Exhausted',
    value: 'false',
  },

];

export const CLASSIFIED_ROLE_TYPES = ['agent', 'seller', 'landlord', 'pg_owner', 'buyer', 'tenant', 'coliving', 'builder', 'pg_seeker']

export const DIRECT_LEAD_VIEWED_OPTIONS = [
  {
    id: 1,
    label: 'Viewed',
    value: 'true',
  },
  {
    id: 2,
    label: 'Not Viewed',
    value: 'false',
  },

];

export const GenderTypes = [
  {
    label: "Male",
    value: "m",
  },
  {
    label: "Female",
    value: "f",
  },
  {
    label: "Other",
    value: "o",
  },
];

export const ReferrerTypes = [
  {
    label: "Hexahome Blog",
    value: "hexahome_blog",
  },
  {
    label: "Web",
    value: "web",
  },
];

export const VisibilityExpiredOptions = [
  {
    label: "Expired",
    value: "true",
  },
  {
    label: "Not Expired",
    value: "false",
  },
];

export const ENABLE_LEAD_AUTOMATION_OPTIONS = [
  {
    label: "Included",
    value: "true",
  },
  {
    label: "Excluded",
    value: "false",
  },
]

export const PAYMENT_STATUS = [
  {
    label: "Captured",
    value: "captured",
  },
  {
    label: "Failed",
    value: "failed",
  },
];

export const SUBSCRIPTION_CREATED_BY = [
  {
    label: "User",
    value: "app",
  },
  {
    label: "Admin",
    value: "admin",
  },
  {
    label: "Payment Link",
    value: "payment_link",
  }
];